import { Box } from "@mui/material";
import { string } from "prop-types";
import React from "react";
import Lottie from "../../atoms/Lottie";
import Typography from "../../atoms/Typography";
import "./PageCircularLoader.scss";

const PageCircularLoader = ({ title }) => {
  return (
    <Box
      className="page-circular-loader-container"
      sx={{ backgroundColor: "foundationColors.supporting.white" }}
    >
      <Lottie size={"64px"} isCommon name="loader" />
      <Typography
        dataAid={"title"}
        variant="body2"
        color="foundationColors.content.secondary"
      >
        {title}
      </Typography>
    </Box>
  );
};

export default PageCircularLoader;

PageCircularLoader.defaultProps = {
  title: "Please wait...",
};

PageCircularLoader.propTypes = {
  title: string,
};
